export default __webpack_public_path__ + "static/media/small.36c97e01.svg";